module.exports = __webpack_public_path__ + "img/20220624171021.df75b49f.png";